import { Loader } from 'components';
import { FC, useMemo } from 'react';
import { Col, ListGroup, Row } from 'react-bootstrap';
import { useQuery } from 'react-query';
import { User } from 'services';
import { UserStyles } from 'types/styles/user';
import { Client } from 'types/user';

import { CACHE_TIME_MS, STYLE_VALUES } from './consts';
import InfoItem from './info/InfoItem';
import { styleItemConfig } from './info/InfoItemConfig';

interface InfoProps {
    client: Client;
    uuid: string;
}
export const Info: FC<InfoProps> = ({ uuid, client }) => {

    const fetchStyles = async () => {
        if (client.request_uuid) {
            const res = await User.styleData(uuid, { session_uuid: client.request_uuid });
            return res?.data;
        }
    };
    const { data: style, isFetching } = useQuery<UserStyles>(
        ['style-data', uuid, client.request_uuid],
        fetchStyles,
        { staleTime: CACHE_TIME_MS }
    );
    const infoNodes = useMemo(() => {
        if (!style) return null;
        return STYLE_VALUES.map((val) => {
            const config = styleItemConfig[val as keyof typeof styleItemConfig];
            if (!config) {
                console.error('Unknown style item:', val);
                return null;
            }
            const content = config.formatter({ style, client });
            if (!content) return null;
            return <InfoItem key={val} icon={config.icon} content={content} />;
        });
    }, [style, client]);

    return (
        <div className="photos">
            {isFetching && <Loader />}
            <Row>
                <Col>
                    <ListGroup>{infoNodes}</ListGroup>
                </Col>
            </Row>
        </div>
    );
};
